import { getRequest, updateRequest } from "./api.service";
import { API_URL } from "../utils/constants";
import {
  ICommon,
  PartnerData,
  PayoutResponse,
  StatusUpdateResponse,
} from "../pages/reviews/types";
import showToast from "../utils/show.toast";

export enum withdrawalStatus {
  PENDING = "pending",
  PAID = "paid",
  // isEmergency: true
}

export const getTotalEmergencyPayout = async (): Promise<number> => {
  const accessToken = localStorage.getItem("token");

  if (!accessToken) {
    return 0;
  }

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  const data = await getRequest<{ result: { users: number } }>(
    `${API_URL}/admin/emergency-withdrawal/count`,
    headers
  );
  return data.result.users;
};

export const getTotalRegularPayout = async (): Promise<number> => {
  const accessToken = localStorage.getItem("token");

  if (!accessToken) {
    return 0;
  }

  const headers = {
    Authorization: `Bearer ${accessToken}`,
  };

  const data = await getRequest<{ result: { users: number } }>(
    `${API_URL}/admin/upcoming-withdrawal/count`,
    headers
  );
  return data.result.users;
};

export enum PartnerStatus {
  REGISTERED = "registered",
  ACCEPTED = "accepted",
  VERIFIED = "verified",
  SUSPENDED = "suspended",
  REJECTED = "rejected",
  DEACTIVATED = "deactivated",
}

export const listPayoutByStatus = async <T>(url: string): Promise<T> => {
  const data = await getRequest<T>(`${API_URL}/${url}`);
  return data;
};

export const getPartnerDetails = async (endpoint: string): Promise<any> => {
  const data = await getRequest<PartnerData>(`${API_URL}/${endpoint}`);
  return data.result;
};

export const getTotalPartnersByStatus = async (): Promise<any> => {
  const data = await getRequest<{ result: { users: number } }>(
    `${API_URL}/merchants/partners/status-counts`
  );
  console.log(data);
  return data.result;
};

export const updatePayoutStatus = async <T>(
  endpoint: string,
  body: T
): Promise<StatusUpdateResponse> => {
  const data = await updateRequest<StatusUpdateResponse>(
    `${API_URL}/${endpoint}`,
    body
  );
  if (data === undefined) {
    showToast("Error occured", false);
  }
  return data as StatusUpdateResponse;
};

//
